import React from 'react';

import SettingsLayout from '../../layouts/SettingsLayout.jsx';

export const SettingsPage = () => <SettingsLayout/>;
